module.exports = __webpack_public_path__ + "static/media/cftc1.1161fe83.jpg";